import ApiService from "../util/api.service";

import utilService from "../util/utils.service";
import { SERVICE_CONFIG_URLS } from "./config";

const RecommendConnectService = {
    deleteCommunityPartner,
    addCommunityPartner,
    suggestPartnerDetails,
    updateCommunityPartner,
    getCommunityPartners,
    getConnectCategories,
    upsertCommunityPartnerSurvey,
    toggleCommunityPartnerSurvey,
    getCommunityPartnerSurvey,
    getSurveysWithPartners,
    getCommunityPartnerSurveyResponses,
};

async function getCommunityPartners(payload) {
    const response = await ApiService.get(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.COMMUNITY_PARTNER_LIST, payload);
    return response;
}

async function addCommunityPartner(payload) {
    const response = await ApiService.post(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.ADD_COMMUNITY_PARTNER, payload);
    return response;
}
async function updateCommunityPartner(payload, id) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.UPDATE_COMMUNITY_PARTNER, id);
    const response = await ApiService.put(url, payload);
    return response;
}

async function deleteCommunityPartner(id, type) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.DELETE_COMMUNITY_PARTNER, id);
    const response = await ApiService.delete(url);
    return response;
}

async function suggestPartnerDetails(id) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.COMMUNITY_PARTNER_DETAILS, { id });
    const response = await ApiService.get(url);
    return response;
}

async function getConnectCategories() {
    const response = await ApiService.get(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.CONNECT_CATEGORIES);
    return response;
}

async function getCommunityPartnerSurvey(id) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.COMMUNITY_PARTNER_SURVEY, { id });
    const response = await ApiService.get(url);
    return response;
}

async function upsertCommunityPartnerSurvey(id, payload) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.COMMUNITY_PARTNER_SURVEY, { id });
    const response = await ApiService.put(url, payload);
    return response;
}

async function toggleCommunityPartnerSurvey(id) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.COMMUNITY_PARTNER_SURVEY_TOGGLE, { id });
    const response = await ApiService.patch(url);
    return response;
}

async function getSurveysWithPartners(payload) {
    const response = await ApiService.get(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.COMMUNITY_PARTNER_SURVEYS_LIST, payload);
    return response;
}

async function getCommunityPartnerSurveyResponses(payload) {
    const response = await ApiService.get(SERVICE_CONFIG_URLS.RECOMMEND_CONNECT.COMMUNITY_PARTNER_SURVEY_RESPONSES, payload);
    return response;
}

export default RecommendConnectService;
